module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-MediumItalic-WebM-c75e406f2f137f7d3f2054ac97c5e714.woff2";